<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-alarm'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="overduePercentageChange"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [isUptrendPositive]="false"
  [widgetDisabled]="true"
  (clicked)="openBreakdownModal()"></app-kpi-widget>